import React from 'react';
import { Outlet } from 'react-router-dom';
import { POSProvider } from 'contexts/POSContext';
import { usePrinterInit } from 'stores/printerStore';

/**
 * Layout component that provides POS context and printer store init for all POS routes.
 * Printer init runs only when user is on POS routes (POS, Payment, Success, Settings, PrinterSetup).
 */
function POSLayout() {
  usePrinterInit();

  return (
    <POSProvider>
      <Outlet />
    </POSProvider>
  );
}

export default POSLayout;
